module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.76e42a6.ttf";